import React, { useEffect, useContext, useRef, useLayoutEffect } from 'react';
import { useDispatch } from 'react-redux';
import _ from 'lodash';
import classNames from 'classnames';
import { isMobile } from 'react-device-detect';

import './MarketsRow.scss';
import { RaceMarket } from '../../../../interfaces/RacingState';
import RacingDetailContext from '../../Context/RacingDetail.context';
import { checkIfCrossEvent } from 'src/utils/racingCombinations';
import Icon from 'src/components/Icon/Icon';

interface MarketsRowProps {
  markets: RaceMarket[],
  onMarketChange: (market: RaceMarket) => void // eslint-disable-line no-unused-vars
}

export default function MarketsRow({ markets, onMarketChange }: MarketsRowProps) {
  const dispatch = useDispatch();

  const { selectedMarket } = useContext(RacingDetailContext);

  const marketSelected = useRef(null);
  const marketsList = useRef(null);

  const isPickMarket = selectedMarket && checkIfCrossEvent(selectedMarket);

  useEffect(() => {
    if (isPickMarket) {
      dispatch.racing.getCrossEvents(selectedMarket.crossEvents);
    }
  }, [selectedMarket]);

  useLayoutEffect(() => {
    marketsList.current?.scroll(marketSelected.current?.offsetLeft - marketsList.current?.offsetLeft, 0);
  }, [selectedMarket]);

  const handleMarketChange = (selectedMarket: RaceMarket) => (e) => {
    e.preventDefault();

    onMarketChange(selectedMarket);
  };

  return (
    <div
      className={
        classNames({
          'market-row__container-mobile': isMobile,
          'market-row__container': !isMobile
        })
      }
      ref={ marketsList }
    >
      {
        _.map(markets, (newMarket) => (
          <div
            ref={ selectedMarket?.code === newMarket.code ? marketSelected : null }
            key={ newMarket.name + newMarket.code }
            className={
              classNames('market-row__market-btn', {
                'market-row__market-btn--selected': selectedMarket?.code === newMarket.code,
                'market-row__market-btn--suspended': newMarket.statusNumber > 1
              })
            }
            onClick={ handleMarketChange(newMarket) }
          >
            <span>
              { newMarket.name.replace(/[_-]/g, ' ') }
            </span>
            { newMarket.statusNumber > 1 && <Icon icon="padlock" className="market-row__suspended-icon" /> }
          </div>
        ))
      }
    </div>
  );
}
